import { Outlet, useNavigate } from "react-router-dom";
import {
  Award,
  CalendarDays,
  ClipboardList,
  Clock,
  FileSpreadsheet,
  LayoutDashboard,
  ScrollText,
  Settings,
  Users,
} from "lucide-react";
import { AppShell } from "@/components/shell/app-shell";
import { clearHrEmployerSession, getHrEmployerSession } from "@/lib/auth/storage";

const groups = [
  {
    label: "People",
    links: [
      { href: "/employer", label: "Today", icon: LayoutDashboard, exact: true },
      { href: "/employer/employees", label: "Employees", icon: Users },
    ],
  },
  {
    label: "Work",
    links: [
      { href: "/employer/tasks", label: "Tasks", icon: ClipboardList },
      { href: "/employer/hours", label: "Hours", icon: Clock },
      { href: "/employer/calendar", label: "Calendar", icon: CalendarDays },
    ],
  },
  {
    label: "Leave",
    links: [{ href: "/employer/leave", label: "Requests", icon: CalendarDays }],
  },
  {
    label: "Recognition",
    links: [{ href: "/employer/awards", label: "Awards", icon: Award }],
  },
  {
    label: "Admin",
    links: [
      { href: "/employer/reports", label: "Reports", icon: FileSpreadsheet },
      { href: "/employer/audit", label: "Audit", icon: ScrollText },
      { href: "/employer/settings", label: "Settings", icon: Settings },
    ],
  },
];

export function EmployerLayout() {
  const navigate = useNavigate();
  const name = getHrEmployerSession()?.employer.name;

  return (
    <AppShell
      product="Employer"
      groups={groups}
      userName={name}
      onSignOut={() => {
        clearHrEmployerSession();
        navigate("/employer/login");
      }}
    >
      <Outlet />
    </AppShell>
  );
}
